<template>
    <div class="examine min-height">
        <el-form ref="infoForm" :model="infoForm" class="info-form" label-width="180px">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="企业全称：" prop="name">
                        <el-input v-model="infoForm.name" disabled placeholder="请输入企业全称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="社会统一信用代码：" prop="code">
                        <el-input v-model="infoForm.code" disabled placeholder="请输入社会统一信用代码"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <div class="flex align-center">
                        <el-form-item class="flex-sub" label="注册地址：" required>
                            <el-select
                                v-model="infoForm.register_address_city"
                                style="width: 100%"
                                placeholder="请选择地区" disabled>
                                <el-option label="北京市" value="北京市"></el-option>
                                <el-option label="其他地区" value="其他地区"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="flex-sub margin-left" label-width="0" prop="registerAddress"  v-if="infoForm.register_address_city === '北京市'" >
                            <el-select
                                v-model="infoForm.registerAddress"
                                style="width: 100%"
                                placeholder="请选择注册地址" disabled>
                                <el-option
                                    v-for="item in address"
                                    :key="item.label"
                                    :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="详细地址：" prop="registerAddressDetail">
                        <el-input v-model="infoForm.registerAddressDetail" disabled placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24"  v-if="infoForm.register_address_city !== '北京市'">
                    <el-form-item label="入会情况说明：" prop="register_address_file">
                        <div class="flex align-center">
                            <el-upload
                                ref="upload4"
                                :action="udhost + '/api/index/upload'"
                                :data="fileData"
                                :file-list="infoForm.register_address_file"
                                :on-preview="handlePreview"
                                :name="'file'"
                                class="flex-sub"
                                disabled>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮寄地址(经营地址)：" prop="mailAddress">
                        <div class="flex align-center">
                            <el-select
                                v-model="infoForm.post_address_city"
                                class="flex-sub"
                                placeholder="请选择地区" disabled>
                                <el-option label="北京市" value="北京市"></el-option>
                                <el-option label="其他地区" value="其他地区"></el-option>
                            </el-select>
                            <el-select
                                v-if="infoForm.post_address_city === '北京市'" v-model="infoForm.mailAddress" class="flex-sub margin-left-sm" disabled
                                placeholder="请选择邮寄地址(经营地址)">
                                <el-option
                                    v-for="item in address"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="详细地址：" prop="mailAddressDetail">
                        <el-input v-model="infoForm.mailAddressDetail" disabled placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="单位性质：" prop="nature">
                        <el-select v-model="infoForm.nature" class="w-all" disabled placeholder="请选择单位性质">
                            <el-option
                                v-for="item in nature"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="会员等级：" prop="level">
                        <el-select v-model="infoForm.level" class="w-all" disabled placeholder="请选择会员等级">
                            <el-option
                                v-for="item in level"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申请时间：" prop="applyTime">
                        <el-date-picker
                            v-model="infoForm.applyTime"
                            class="w-all"
                            disabled
                            placeholder="请选择申请时间"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否新会员：" prop="newMember">
                        <el-select v-model="infoForm.newMember" class="w-all" disabled placeholder="请选择是否新会员">
                            <el-option
                                v-for="item in newMember"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="注册资本（万元）：" prop="memberCapital">
                        <el-input v-model="infoForm.memberCapital"
                            disabled
                            placeholder="请输入注册资本（万元）"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="会员分类：" prop="memberType">
                        <el-select v-model="infoForm.memberType" class="w-all" disabled placeholder="请选择会员分类">
                            <el-option
                                v-for="item in memberType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item v-if="infoForm.memberType === 1" label="服务类别(可多选)：" prop="moreType">
                        <el-select v-model="infoForm.moreType" class="w-all" disabled multiple placeholder="请选择服务类别">
                            <el-option
                                v-for="item in supply"
                                :key="item.value"
                                :label="item.label +'：'+ item.desc"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item v-if="infoForm.memberType === 2" label="服务类别(可多选)：" prop="moreType">
                        <el-select v-model="infoForm.moreType" class="w-all" disabled multiple placeholder="请选择服务类别">
                            <el-option
                                v-for="item in demand"
                                :key="item.value"
                                :label="item.label  +'：'+ item.desc"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="专委会职务：" prop="post">
                        <el-select v-model="infoForm.post" class="w-all" filterable multiple placeholder="请选择专委会职务">
                            <el-option
                                v-for="item in committeeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人代表姓名：" prop="legalPerson">
                        <el-input v-model="infoForm.legalPerson" disabled placeholder="请输入法人代表姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人代表电话：" prop="legalPersonPhone">
                        <el-input v-model="infoForm.legalPersonPhone" disabled placeholder="请输入法人代表电话"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系人姓名：" prop="contacts">
                        <el-input v-model="infoForm.contacts" disabled placeholder="请输入联系人姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系人电话：" prop="contactsPhone">
                        <el-input v-model="infoForm.contactsPhone" disabled placeholder="请输入联系人电话"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系人邮箱：" prop="contactsEmail">
                        <el-input v-model="infoForm.contactsEmail" disabled placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入会介绍人：" prop="introducePerson">
                        <el-input v-model="infoForm.introducePerson" disabled placeholder="请输入入会介绍人"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="介绍人会员等级：" prop="introducePersonLevel">
                        <el-select v-model="infoForm.introducePersonLevel" class="w-all" disabled
                                   placeholder="请选择介绍人会员等级">
                            <el-option
                                v-for="item in introduce"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="公司简介：" prop="desc">
                        <el-input v-model="infoForm.desc" :rows="5" disabled placeholder="请输入公司简介"
                                  type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="营业范围：" prop="business">
                        <el-input v-model="infoForm.business" :rows="5" disabled placeholder="请输入营业范围"
                                  type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="业绩情况：" prop="performance">
                        <el-input v-model="infoForm.performance" :rows="5" disabled placeholder="请输入业绩情况"
                                  type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="营业执照：" prop="license">
                        <!--                        <el-link type="primary" :href="showhost + infoForm.license.url" target="_blank">-->
                        <!--                            {{ infoForm.license.name }}-->
                        <!--                        </el-link>-->
                        <el-image
                            v-if="infoForm.license && infoForm.license.url"
                            :fit="'scale-down'"
                            :preview-src-list="[showhost + infoForm.license.url]"
                            :src="showhost + infoForm.license.url"
                            style="width: 200px; height: 200px;">
                        </el-image>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="会员承诺书：" prop="promise">
                        <!--                        <el-link type="primary" :href="showhost + infoForm.promise.url" target="_blank">-->
                        <!--                            {{ infoForm.promise.name }}-->
                        <!--                        </el-link>-->
                        <el-image
                            v-if="infoForm.promise && infoForm.promise.url"
                            :fit="'scale-down'"
                            :preview-src-list="[showhost + infoForm.promise.url]"
                            :src="showhost + infoForm.promise.url"
                            style="width: 200px; height: 200px;">
                        </el-image>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="其他附件：">
                        <p v-for="(item,index) in infoForm.other" :key="index">
                            <el-link :href="showhost + item.url" target="_blank" type="primary">{{
                                    item.name
                                }}
                            </el-link>
                        </p>

                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="infoForm.change_file.length">
                    <el-form-item label="工商信息更改文件：">
                        <p v-for="(item,index) in infoForm.change_file" :key="index">
                            <el-link :href="showhost + item.url" target="_blank" type="primary">{{
                                    item.name
                                }}
                            </el-link>
                        </p>

                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label-width="0">
                        <div v-if="user_role === userCompanyInfo_state" class="flex align-center justify-around">
                            <el-button class="w-20" type="danger" @click="userExamine(2)">驳回</el-button>
                            <el-button class="w-20" type="primary" @click="userExamine(1)">通过</el-button>
                        </div>
                        <div v-if="reject_reason" style="color: #9a0000;">
                            上一次驳回原因：{{ reject_reason }}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>


        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :title="'驳回原因'"
            :visible.sync="dialog"
            center
            width="480px">
            <el-form ref="descForm" :model="descForm" :rules="rules">
                <el-form-item prop="name">
                    <el-input v-model="descForm.desc" :rows="5" placeholder="请输入驳回原因" type="textarea"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm('descForm')">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('descForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import {address, demand, introduce, level, memberType, nature, newMember, optionList, supply} from "@/utils/utils";
import {SHOWHOST, UDHOST} from '@/config/index'
import {getInformation_update} from "@/api/member";
import {checkInfoNow, userExamine} from "@/api/admin";
import {getCommittee} from "@/api/common";
// import {getInformation, submitInfo} from "@/api/member";

export default {
    name: "examineDetail",
    data() {
        return {
            address: optionList(false, address),
            nature: optionList(false, nature),
            level: optionList(false, level),
            newMember: optionList(true, newMember),
            memberType: optionList(false, memberType),
            supply: optionList(false, supply),
            demand: optionList(false, demand),
            introduce: optionList(false, introduce),
            committeeList: [],
            infoForm: {
                name: '',
                code: '',
                register_address_city: '北京市',
                registerAddress: '',
                registerAddressDetail: '',
                post_address_city: '北京市',
                mailAddress: '',
                mailAddressDetail: '',
                nature: '',
                level: '',
                applyTime: '',
                newMember: '',
                memberType: '',
                moreType: '',
                post: '',
                legalPerson: '',
                legalPersonPhone: '',
                contacts: '',
                contactsPhone: '',
                contactsEmail: '',
                introducePerson: '',
                introducePersonLevel: '',
                desc: '',
                business: '',
                performance: '',
                license: '',
                promise: '',
                ohter: [],
                change_file: [],
                agree: '',
                register_address_file:[],
                memberCapital: ''
            },
            dialog: false,
            descForm: {
                desc: ''
            },
            rules: {
                desc: [{required: true, message: '请输入驳回原因', trigger: 'blur'}],
            },
            state: 0,
            status: 0,
            userCompanyInfo_state: '',
            reject_reason: '',
            user_role: '',
        }
    },
    computed: {
        udhost() {
            return UDHOST
        },
        showhost() {
            return SHOWHOST
        },
        fileData() {
            return {
                // token: this.user.token
            };
        },
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/admin/examine', "会员审核  / 审核详情", true, 'icon-jibenxinxi1');
        this.getCommittee()
        this.getDetail()
        this.checkInfoNow()
    },
    components: {},
    methods: {
        //  获取专职
        async getCommittee() {
            let _data = await getCommittee()
            this.committeeList = _data.data
        },
        //  审核驳回提交
        async submitData() {
            let _state = await userExamine(2, this.$route.query.id, this.descForm.desc)
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            } else {
                this.$message.error(_state.msg)
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        //  审核驳回 取消
        resetForm() {
            this.dialog = false
        },
        // 审核通过
        userExamine(num) {
            if (num === 1) {            //通过
                this.$confirm('此操作将通过会员信息审核', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center: true
                }).then(() => {
                    this.surePass(num)
                })
            } else if (num === 2) {     //  驳回
                this.dialog = true
            }
        },
        async surePass(num) {
            let _state = await userExamine(num, this.$route.query.id, '')
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            } else {
                this.$message.error(_state.msg)
            }

        },
        //  获取基本信息
        async getDetail() {
            let _data = await getInformation_update(this.$route.params.id)
            if (_data.data) {
                this.infoForm = {
                    name: _data.data.company_name,
                    code: _data.data.company_code,
                    register_address_city: _data.data.register_address_city || this.infoForm.register_address_city,
                    registerAddress: _data.data.register_address_county,
                    registerAddressDetail: _data.data.register_address_detail,
                    post_address_city: _data.data.post_address_city || this.infoForm.post_address_city,
                    mailAddress: _data.data.post_address_county,
                    mailAddressDetail: _data.data.post_address_detail,
                    nature: _data.data.company_type_id ? _data.data.company_type_id : '',
                    level: _data.data.company_level_id ? _data.data.company_level_id : '',
                    applyTime: _data.data.apply_time ? new Date(_data.data.apply_time) : '',
                    newMember: _data.data.is_new !== '' ? _data.data.is_new : '',
                    memberType: _data.data.member_type ? _data.data.member_type : '',
                    moreType: _data.data.member_type_detail_id ? _data.data.member_type_detail_id.split(',').map(Number) : [],
                    post: _data.data.special_job ? _data.data.special_job.split(',').map(Number) : [],
                    legalPerson: _data.data.legal_person_name,
                    legalPersonPhone: _data.data.legal_person_tel,
                    contacts: _data.data.tel_name,
                    contactsPhone: _data.data.tel_number,
                    contactsEmail: _data.data.tel_email,
                    introducePerson: _data.data.introducer,
                    introducePersonLevel: _data.data.introducer_level_id ? _data.data.introducer_level_id : '',
                    desc: _data.data.company_desc,
                    business: _data.data.business_range,
                    performance: _data.data.achievement_desc,
                    license: _data.data.business_license ? JSON.parse(_data.data.business_license) : '',
                    promise: _data.data.member_commitment ? JSON.parse(_data.data.member_commitment) : '',
                    other: JSON.parse(_data.data.other_file),
                    change_file: _data.data.change_file ? JSON.parse(_data.data.change_file) : [],
                    register_address_file: _data.data.register_address_file ? JSON.parse(_data.data.register_address_file) : [],
                    memberCapital: _data.data.capital ? _data.data.capital : ''
                }
                this.state = _data.data.state
                this.status = _data.data.status
            } else {
                this.infoForm.name = this.user.user_name
            }
            this.$refs.infoForm.clearValidate()
        },
        //  审核校验
        async checkInfoNow() {
            let _data = await checkInfoNow(this.$route.params.id)
            this.userCompanyInfo_state = _data.data.userCompanyInfo_state
            this.user_role = _data.data.user_role
            this.reject_reason = _data.data.reject_reason

        },
        //上传文件预览
        handlePreview(file) {
            window.open(file.url)
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.examine {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
}
</style>